<div class="flex justify-center w-full" [attr.data-testid]="testId()">
  <div [ngClass]="layoutClasses">
    @for (item of items(); track trackByFn()(i, item); let i = $index) {
      <ng-container
        *ngTemplateOutlet="cardTemplate(); context: {$implicit: item, index: i}"
      ></ng-container>
    } @empty {
      <p class="text-center text-gray-600">No cards available.</p>
    }
  </div>
</div>
